import styled from 'styled-components';
import { TextButton } from 'ui/button';
import { FormField } from 'ui/formField';
import { ModalBody } from 'ui/modal';
import { BasicSelect } from 'ui/selects';
import { heading4, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const Header = styled.div`
  ${heading4}
  padding-top: ${spacing.plusHalf};
  padding-left: ${spacing.plusHalf};
`;

export const StyledModalBody = styled(ModalBody)`
  overflow-y: unset;
`;

export const StyledFormField = styled(FormField)`
  padding: ${spacing.plusHalf} 0 0 0;
`;

/** Setting option-wrapper max-height to 152px allows user to see up to 3 placements at a time */
export const StyledSelect = styled(BasicSelect)`
  display: block;

  [data-test='basic-select-trigger-form-field-placement-select'] {
    max-width: ${pxToRem(624)};
  }

  [data-test='basic-select-option-wrapper-form-field-placement-select'] {
    max-height: ${pxToRem(152)};
  }
`;

export const PlacementWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
`;

export const RightAlignedHelpText = styled(TextButton)`
  display: flex;
  justify-content: flex-end;
`;
